export type Token = {
  access_token: string;
  refresh_token: string;
  id_token: string;
  scope: string;
  expires_in: number;
  token_type: string;
};

/**
 * Use this enum to check the status of a stripe subscription.
 * Possible values are incomplete, incomplete_expired, trialing, active, past_due, canceled, or unpaid.
 * For more information on the means for each status check the stripe documentation.
 *
 * https://docs.stripe.com/api/subscriptions/object#subscription_object-status
 */
export enum STRIPE_SUBSCRIPTION_STATUS {
  /**
   * For collection_method=charge_automatically a subscription moves into incomplete if
   * the initial payment attempt fails.
   */
  Incomplete = "incomplete",
  /**
   * If the first invoice is not paid within 23 hours, the subscription transitions to
   * incomplete_expired.
   */
  IncompleteExpired = "incomplete_expired",
  /**
   * A subscription that is currently in a trial period is trialing and moves to active when
   * the trial period is over.
   */
  Trialing = "trialing",
  /**
   * An active subscription means the subscription is in good standing and no longer in a trial.
   * Most of the time this is the current subscription we should use since our system currently
   * only allows one active subscription at a time.
   */
  Active = "active",
  /**
   * If subscription collection_method=charge_automatically, it becomes past_due when payment is
   * required but cannot be paid (due to failed payment or awaiting additional user actions).
   */
  PastDue = "past_due",
  /**
   * Once Stripe has exhausted all payment retry attempts, the subscription will become canceled
   * or unpaid (depending on your subscriptions settings).
   */
  Canceled = "canceled",
  /**
   * Once Stripe has exhausted all payment retry attempts, the subscription will become canceled
   * or unpaid (depending on your subscriptions settings).
   */
  Unpaid = "unpaid",
}
